import {createContext} from 'react';

import {Reservation} from 'lib/api/backend.schemas';

const ReservationContext = createContext<Reservation>({} as Reservation);

export default ReservationContext;
